import React, { forwardRef, RefObject } from 'react';

import { PieChartProps } from './types';
import { StyledPieChart } from './styles';

export const LoadingPieChart = forwardRef<HTMLDivElement, PieChartProps>(
  (props, ref) => {
    const { className, ...forwardedProps } = props;

    return (
      <StyledPieChart
        {...forwardedProps}
        className={className}
        ref={ref as RefObject<HTMLDivElement>}
      >
        Loading...
      </StyledPieChart>
    );
  }
);
